module.exports = __webpack_public_path__ + "2c1a70fe57f13853267095b503ba4a2e.png";